
import { Course } from '../types';

export const dra_tactics: Course = {
  id: "dra_tactics",
  title: "The DRA: Negotiation & Settlement Tactics",
  description: "Master the most critical 'settlement' hearing. Learn how to interpret reports, negotiate with solicitors, and use judicial indications to your advantage.",
  icon: "🤝",
  totalModules: 13,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    13: { id: 13, title: "Slide 13", slides: [{ title: "Slide 13", content: `<div class="flex justify-center"><img src="/images/courses/dra_tactics/Slide13.PNG" alt="Slide 13" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "What is the primary objective of the Dispute Resolution Appointment (DRA) in Family Court?",
        "o": [
            "To serve as the final trial.",
            "To allow the Judge to pivot from mediator to case manager.",
            "To determine if a trial can be avoided through a negotiated settlement.",
            "To file the Section 7 (Cafcass) or Section 37 (Social Services) report."
        ],
        "a": 2
    },
    {
        "q": "According to the course content, when does the Dispute Resolution Appointment (DRA) strictly occur?",
        "o": [
            "Before the first hearing.",
            "Before the Section 7 or Section 37 report has been filed.",
            "After a Section 7 (Cafcass) or Section 37 (Social Services) report has been filed.",
            "Concurrently with the final trial."
        ],
        "a": 2
    },
    {
        "q": "What critical step is advised for analyzing the Section 7 report as a negotiation roadmap?",
        "o": [
            "To dismiss its findings entirely.",
            "To divide the analysis into points you accept and points you intend to challenge.",
            "To accept all recommendations without question.",
            "To prepare a generic argument against all points."
        ],
        "a": 1
    },
    {
        "q": "What does the 'Walk-Away Point' refer to when establishing your Zone of Possible Agreement before court?",
        "o": [
            "Your ideal outcome or original request.",
            "A compromise you can realistically live with.",
            "The absolute line you will not cross where compromise becomes unacceptable.",
            "The point where you have built sufficient judicial capital."
        ],
        "a": 2
    },
    {
        "q": "If a settlement is reached at the DRA, what are the two main components of the legally binding Consent Order issued by the Judge?",
        "o": [
            "Case Manager's notes and mediator's recommendations.",
            "The Recitals (preamble/promises) and the Formal Orders (legally binding rules).",
            "Tactical concessions and judicial indications.",
            "Points to challenge and points to accept."
        ],
        "a": 1
    }
]
};
